import api from '@/api';
import { ForexDraftFilter } from "@/feature/Forex/api/draft/forex-draft.interface";
import { mapForexDraftList } from "@/feature/Forex/api/form/forex-form.utils";
import { isSuccessResponseStatusCode } from "@/api/handler";
// import ObjectUtils from "@/modules/Object/ObjectUtils";
import {
	getForexStatusFromUserRole,
	mapCountByPaymentOrderCount, mapForexToApproveCount
} from "@/feature/Forex/api/approval/forex-approval.utils";
import { ForexToApproveCount } from "@/feature/Forex/api/approval/forex-approval.interface";

export const $getForexListToApprove = (params?: ForexDraftFilter) => api
	.get('foreign-exchange/list-to-approve', {
		handler: { disableLoader: true },
		request: { params },
	})
	// .then(() => ObjectUtils.deepCopy(
	// 	ObjectUtils.deepCopy(require('../__mock__/list-to-approve.json').data)
	// ))
	.then(mapForexDraftList);

export const $deleteForeignExchange = async (ids: number[]) => api
	.post('foreign-exchange/delete', { ids }, {
		handler: { returnData: false },
	})
	.then(response => isSuccessResponseStatusCode(response?.status));

export const $requestPaymentOrdersCount = (
	endpoint: string
): any => {
	let cachedRequest: any = null;

	const sendRequest: any = (params?: any): Promise<number> => {
		if (cachedRequest) return cachedRequest;

		// return cachedRequest = require('../__mock__/swift-payment.json').data;

		return cachedRequest = api
			.get(endpoint, {
				request: {
					params: {
						status: getForexStatusFromUserRole(),
						...(params || {})
					}
				}
			})
			.then(response => {
				sendRequest.cachedResponse = response;

				return response;
			})
			.then(mapCountByPaymentOrderCount)
			.finally(() => cachedRequest = null);
	};

	return sendRequest;
};

export const $getSwiftPaymentsToApproveCount = $requestPaymentOrdersCount(
	'swift-payment/count'
);

export const $getUzsPaymentsToApproveCount = $requestPaymentOrdersCount(
	'payment-order/count'
);

export const $getForexToApproveCount = (): Promise<ForexToApproveCount> => {
	// return require('../__mock__/foreign-exchange-count.json').data;

	return api
		.get('foreign-exchange/count')
		.then(mapForexToApproveCount);
}